export const gradientDarkColor = 'rgba(0, 96, 250, 1)';
export const gradientLightColor = 'rgba(204, 116, 245, 1)';

export const USER_PROFILE = 'user';
export const TEAM_PROFILE = 'team';

export const WHITELISTED_DOMAINS = ['bluequbit', 'honda-ri'];
export const WHITELISTED_EMAILS = ['tehayk+9@gmail.com'];
